export default __webpack_public_path__ + "static/media/lan.7a266eff.svg";